var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "historical_card" }, [
    _vm.isStudent
      ? _c("div", { staticClass: "item_title_student" }, [
          _c("p", [_vm._v(_vm._s(_vm.cardValue.typeText || ""))]),
          _c(
            "div",
            {
              class: [
                _vm.cardValue.replyStatusValue == "1" ? "status_color" : "",
              ],
            },
            [_vm._v(_vm._s(_vm.cardValue.replyStatusText || "无"))]
          ),
        ])
      : _c("div", { staticClass: "item_title_teacher" }, [
          _c(
            "div",
            { staticClass: "teacher_title" },
            [
              _c("van-image", {
                attrs: {
                  radius: "50%",
                  width: "48",
                  height: "48",
                  fit: "cover",
                  src: _vm._f("imgFormat")(_vm.cardValue.photo),
                },
                scopedSlots: _vm._u([
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _c("img", {
                          staticClass: "err_img",
                          attrs: {
                            src: _vm._f("imgFormat")(_vm.defaultImg),
                            alt: "",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("div", { staticClass: "teacher_info" }, [
                _c("p", { staticClass: "info_name" }, [
                  _vm._v(_vm._s(_vm.cardValue.stuName || "")),
                ]),
                _c("span", { staticClass: "info_class" }, [
                  _vm._v(_vm._s(_vm.cardValue.className || "")),
                ]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "info_status" }, [
            _vm._v(_vm._s(_vm.cardValue.typeText || "")),
          ]),
        ]),
    _c("div", { staticClass: "item_content" }, [
      _vm._v(_vm._s(_vm.cardValue.suggest || "")),
    ]),
    _c(
      "div",
      { staticClass: "item_img" },
      _vm._l(_vm.imgUrl(), function (item, index) {
        return _c("van-image", {
          key: index,
          attrs: {
            radius: "5",
            width: "80",
            height: "80",
            fit: "cover",
            src: item.relativePath,
          },
          scopedSlots: _vm._u(
            [
              {
                key: "error",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "err_img",
                      attrs: {
                        src: require("../../assets/styles/themes/img/submissionErr_mobile.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        })
      }),
      1
    ),
    _vm.cardValue.suggestReplyList && _vm.cardValue.suggestReplyList.length
      ? _c("div", { staticClass: "item_reply" }, [
          _c("span", [_vm._v("回复内容：")]),
          _c("div", [
            _vm._v(_vm._s(_vm.cardValue.suggestReplyList[0].detail || "")),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "item_date" }, [
      _c("div", [
        _vm._v("提交日期：" + _vm._s(_vm.cardValue.dsCreateTime || "")),
      ]),
      _c("span", { on: { click: _vm.toDetailUrl } }, [_vm._v("详情")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }